import React from "react";
import CustomMenu from "../../../../../../components/Menu";
import RemoveUser from "../RemoveUser";

const UsersList = ({
  anchorEl,
  open,
  closeUserList,
  users,
  isColabrotar,
  ownerId,
  filterUserById,
  selectedUsers,
  removeSelectedUser,
  handleRemoveColabrotor,
  setOpenEditUserDialog,
  board,
  canManageUsers,
}) => {
  return (
    <CustomMenu
      id="user-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={closeUserList}
      className="assign-board-owner-list"
    >
      {users?.map((user, index) => (
        <React.Fragment key={`board-user-${user?.user_id}-${index}`}>
          <RemoveUser
            ownerId={ownerId}
            user={user}
            onClick={() => filterUserById(user?.user_id)}
            closeUserList={closeUserList}
            isSelected={selectedUsers?.includes(String(user?.user_id))}
            removeSearchParam={removeSelectedUser}
            isColabrotar={isColabrotar}
            handleRemoveColabrotor={handleRemoveColabrotor}
            setOpenEditUserDialog={setOpenEditUserDialog}
            board={board}
            boardOwnerId={board?.owner_user_id}
            canManageUsers={canManageUsers}
          />
        </React.Fragment>
      ))}
    </CustomMenu>
  );
};

export default UsersList;
